module.exports = __webpack_public_path__ + "static/media/shape1.5219a2dc.svg";